import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import dayjs from 'dayjs';
import API from '@sesame/web-api';

import { ICustomer, ISalesorder, ISalesorderType, ILoadState } from 'src/types';
import { getCustomerCacheList, getCustomerCacheMap } from 'src/util/resources/CustomerCache';
import { getSalesorderTypeCacheList } from 'src/util/resources/SalesorderTypesCache';
import { SalesorderCard } from 'src/pages/Salesorder/SalesorderCard';
import { SalesorderMaterial } from 'src/pages/Salesorder/Material';
import { WarrantiesForSalesorder } from 'src/pages/Salesorder/Warranties';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';


// Make a string based object to ease form manipulatin

type IFormData = { [Property in keyof ISalesorder]: string; }
type fieldNames = keyof IFormData;

export default function DisplaySalesorder() {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [displayState, setDisplayState] = useState(ILoadState.NEW);
  const [salesorderId, setSalesorderId] = useState(0);
  const [bcSalesorder, setBcSalesorder] = useState('');

  const getSalesorder = (salesorderId: number) => {
    getAccessTokenSilently().then(accessToken => {

    API.get(accessToken, `api/v1/salesorder/${salesorderId}`)
      .then((response) => {
        if (!response) {
          Alert(AlertTypes.ERROR, 'Salesorder  Not Found');
          setDisplayState(ILoadState.ERROR);
          return;
        }
        const salesorder = response.data as ISalesorder;
        setBcSalesorder(salesorder.salesorderRef);
        setDisplayState(ILoadState.READY);
      })
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Salesorder Not Found');
          setDisplayState(ILoadState.ERROR);
          return;
        }
        console.log('Salesorders err: ' + JSON.stringify(err));
        setDisplayState(ILoadState.ERROR);
        Alert(AlertTypes.ERROR, 'Salesorders: ' + err.message);
      });
    });
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const soId = parseInt(queryParams.get('salesorder') || '0');
    setSalesorderId(soId);
    getSalesorder(soId);
  }, [])

  if (displayState == ILoadState.NEW || displayState == ILoadState.LOADING) {
    return <span><div data-uk-spinner></div></span>
  }
  if (displayState == ILoadState.ERROR) {
    return <div>Error loading salesorder</div>
  }

  return <div>
    <div className="uk-container">
      <h1>Sales Order {bcSalesorder}</h1>

      <div className="uk-grid">
        <div className="uk-card uk-card-default uk-card-body uk-width-1-2@m">
          <WarrantiesForSalesorder salesorderId={salesorderId} />
        </div>

        <div className="uk-card uk-card-default uk-card-body uk-width-1-2@m">
          <SalesorderCard salesorderId={salesorderId} />
        </div>

        <div className="uk-card uk-card-default uk-card-body uk-width-1-1@m">
          <SalesorderMaterial salesorderId={salesorderId} />
        </div>
      </div>
    </div>
  </div>
}
